<template>
    <div>


        <section id="signin">


            <div class="columns mt0 mb0 pb0">

                <div class="column fullcol is-7 is-hidden-touch">
                    <div class="loginbg" :style="'background-image:url(\'/static/images/signin/Imagem'+rdm+'.jpg\')'">

                        <p class="loginbg-txt">
                            O FACILIMO É A PLATAFORMA QUE <br>
                            AJUDA A REALIZAR PROJECTOS
                        </p>


                        <div class="loginbgsocial">
                            <p>
                                SIGA-NOS
                            </p>
                            <p>
                               <i class="fa fa-facebook-square"></i>
                               <i class="fa fa-instagram"></i>
                               <i class="fa fa-linkedin-square"></i>
                            </p>

                        </div>


                    </div>

                </div>

                <div class="column fullcol is-5-desktop" id="rightcol" style="background-color: #f1f1f1; display:flex; flex-direction:column;">


                    <div class="formcontainer" style="height:100%;">


                        <div class="loginaction">



                            <div class="loginlogo" @click="$router.push({path:'/'})" style="cursor:pointer;">
                                <img src="/static/images/layout/logotop.png" alt="FACILIMO">
                            </div>

                            <div id="signinflow">

                                <transition name="fade">

                                    <div id="flow-step-1">

                                        <p id="aceda">REDEFINA SUA PASSWORD</p>

                                        <div class="step1container">

                                            <form>

                                                <div class="columns">
                                                    <div class="column">
                                                        <div :class="{'badinput': errors.has('password')}" style="border:solid 1px white" class="field has-addons">
                                                            <input style="border:none" class="formfield" :type="hide ? 'password' : 'text'" name="password" data-vv-as="password" v-model="password" v-validate="'required|min:8'" placeholder="Nova password">
                                                            <div class="control is-expanded">
                                                                <a class="button" style="border:none;height:100%" @click="hide = !hide">
                                                                    <transition name="fade">
                                                                        <i v-if="hide" class="fa fa-eye" ></i>
                                                                        <i v-if="!hide" class="fa fa-eye-slash" ></i>
                                                                    </transition>

                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="columns" style="padding:0 0.7rem;">
                                                            <div class="column is-narrow">
                                                                <p style="font-size: 0.7rem;"><em>Força da senha: </em></p>

                                                            </div>
                                                            <div class="column">
                                                                <progress class="progress is-small"  :class="{
                                                    'is-danger': passScore <= 40,
                                                    'is-warning': passScore > 40 && passScore <= 65,
                                                    'is-success': passScore > 65
                                                    }":value="passScore" max="100"></progress>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="columns">
                                                    <div class="column">
                                                        <div :class="{'badinput': errors.has('passwd_c')}" style="border:solid 1px white" class="field has-addons">
                                                            <div class="control is-expanded">
                                                                <input style="border:none" class="formfield" :type="hide ? 'password' : 'text'" name="passwd_c" data-vv-as="confirmação de password" v-model="passwd_c" v-validate="'required|confirmed:password'" placeholder="Confirme a sua password">
                                                            </div>

                                                            <div class="control">
                                                                <a class="button" style="border:none;height:100%" @click="hide = !hide">
                                                                    <transition name="fade">
                                                                        <i v-if="hide" class="fa fa-eye" ></i>
                                                                        <i v-if="!hide" class="fa fa-eye-slash" ></i>
                                                                    </transition>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>

                                        </div>

                                    </div>

                                </transition>

                            </div>

                            <div class="procceed" style="margin-top: 3rem;">
                                <a class="button is-primary" @click="resetPass" style="margin:0; font-weight: 600;">
                                    REDEFINIR PASSWORD
                                </a>

                            </div>

                        </div>

                    </div>



                </div>

            </div>

        </section>

        <transition name="fade">
            <div class="modal" :class="{'is-active': loading}">
                <div class="modal-background" style="background-color: rgba(10, 10, 10, 0.50);">

                    <i class="fa fa-spinner fa-pulse fa-3x" style="position: absolute;top: 50%;left: 50%;"></i>

                </div>

            </div>
        </transition>

    </div>

</template>

<script>
import { store } from "../store";
import { mask } from "vue-the-mask";
import { removeChatMixin } from "../plugins/removeChatMixin";
import { notificationMixin } from "../plugins/notificationMixin";
import { apiUrl } from "../vars";
import VueScript2 from "vue-script2";
import {
  loadFbSdk,
  getFbLoginStatus,
  fbLogout,
  fbLogin
} from "../plugins/facebook";

export default {
  mixins: [removeChatMixin, notificationMixin],

  data() {
    return {
      email: this.$route.query.email,
      token: this.$route.query.token,

      loading: false,
      password: null,
      passwd_c: null,
      hide: true,
      rdm: 1
    };
  },

  created() {
    this.rdm = Math.ceil(Math.random() * 3);
  },

  computed: {
    passScore() {
      if (this.password) {
        if (this.password.length < 8) {
          return 5 + 5 * this.password.length;
        } else {
          let types = 0;
          if (this.password.match("([a-z])+")) {
            types += 1;
          }
          if (this.password.match("([A-Z])+")) {
            types += 2;
          }
          if (this.password.match("([0-9])+")) {
            types += 3;
          }
          if (this.password.match("([^A-Za-z0-9])+")) {
            types += 4;
          }
          return Math.min(5.5 * this.password.length, 60) + 4 * types;
        }
      } else {
        return 5;
      }
    }
  },

  methods: {
    resetPass() {
      let that = this;
      this.loading = true;

      this.$validator.validateAll().then(result => {
        if (result) {
          let o = {
            password: this.password,
            email: this.email,
            token: this.token
          };
          axios
            .post(apiUrl + "/auth/reset", o)
            .then((response, context = this) => {
              context.error = null;
              context.success = "Password alterada com sucesso";
              context.loading = false;

              context.$router.push({
                name: "signin",
                params: {
                  message: "Password alterada com sucesso."
                }
                //name: 'fetch'
              });
            })
            .catch((error, context = this) => {
              //context.l_login = false;

              switch (error.response.status) {
                case 500:
                  context.error =
                    "Erro no servidor. Favor tentar novamente mais tarde.";
                  break;
                case 401:
                  context.error = "E-mail e/ou password inválidos.";
                  break;
                default:
                  context.error =
                    "Erro " +
                    error.response.status +
                    ": " +
                    error.response.statusText;
              }
              //context.l_login = false;
            });
        }
        that.error = "Verifique as passwords informadas.";
        this.loading = false;
      });
    }
  },

  watch: {}
};
</script>

<style scoped lang="scss">
.signup {
  padding: 1rem 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.button2 {
  margin-left: 1rem;
  font-size: 0.8rem;
  padding: 1.2rem 1rem;
  font-weight: 700;
}

.button2:hover {
  background-color: white !important;
}

#signin {
  position: relative;
}

#signin .columns {
  position: relative;
}

#signin .fullcol {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  padding: 0;
}

.loginbg {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  position: relative;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.loginbg-txt {
  text-align: center;
  font-size: 1.35rem;
  color: white;
  font-weight: 600;
  line-height: 1.2;
}

.loginbgsocial {
  text-align: center;
  padding: 4rem 0 2rem;
}

.loginbgsocial p {
  text-align: center;
  color: #e90054;
  font-size: 0.9rem;

  font-weight: 600;
}

.loginbgsocial i {
  text-align: center;
  font-size: 1.15rem;
  color: white;
  padding: 0.3rem;
  font-weight: 500;
}

.loginaction {
  background-color: #f1f1f1;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.loginlogo {
  padding: 4.5rem 0 0;
}

#aceda {
  margin-top: 5rem;
  color: #2d3256;
  font-weight: 600;
  text-align: left;
  padding: 1rem 0;
  font-size: 1.2rem;
}

.step1container {
  padding: 1rem 0;
}

.loginprompt {
  margin-top: 1rem;
  color: #848a96;
  font-size: 0.8rem;
}

#loginprompt {
  color: #e90054;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.8rem;
}

form .column {
  padding: 0.3rem;
}

.loginlogo img {
  height: 3rem;
}

.formfield {
  //border: solid 1px #848a96;
  background-color: white;
  padding: 0.5rem;
  width: 100%;
  font-size: 0.9rem;
}

.fbbut {
  border: none;
  margin: 0.1rem;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
}

.fbbut:hover {
  border: none;
}

.gobut {
  border: none;
  margin: 0.1rem;
  justify-content: left;
  padding-left: 1rem;
  padding-right: 1rem;
}

.gobut:hover {
  border: none;
}

.procceed {
  text-align: center;
  padding: 0 0 4.5rem;
}

.procceed .button {
  padding: 1.25rem 3rem;
  font-size: 0.85rem;
  margin: 1rem;
}

.formcontainer {
  margin: auto;
  margin-bottom: 6rem;
  max-width: 20rem;
  min-width: 20rem;
}

input {
  border: solid 1px #f1f1f1;
}

.badinput {
  border: solid 1px #e90054 !important;
}

@media screen and (max-width: 768px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 570px) and (min-width: 769px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 720px) {
  .procceed {
    text-align: center;
    padding: 0 0 3rem;
  }

  .loginlogo {
    padding: 3rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue